import type { LabeledStat } from '@/components/common/StatCardGrid';
import { TAKA_SYMBOL } from '@/constants/app.constants';
import type { AssignedInstitute, DcrSheet } from '../types/product.types';

export const SHEET_TAB_CARD_SLOTS = 5;

function getGrandTotalCard(sheet: DcrSheet | undefined): LabeledStat {
  const totals = sheet?.totals;
  return {
    key: 'grandTotal',
    label: 'Grand Total',
    value: totals === undefined ? undefined : totals.fareClaimed + totals.expenseClaimed,
    unit: TAKA_SYMBOL,
  };
}

export function getDcrEntryStatCards(sheet: DcrSheet | undefined): LabeledStat[] {
  const totals = sheet?.totals;
  return [
    {
      key: 'dcrCount',
      label: 'DCR Entries',
      value: totals?.dcrCount,
    },
    {
      key: 'specimenQty',
      label: 'Specimens',
      value: totals?.specimenQty,
    },
    {
      key: 'fareClaimed',
      label: 'Fare Claimed',
      value: totals?.fareClaimed,
      unit: TAKA_SYMBOL,
    },
    {
      key: 'fareApproved',
      label: 'Fare Approved',
      value: totals?.fareApproved,
      unit: TAKA_SYMBOL,
    },
    getGrandTotalCard(sheet),
  ];
}

export function getExpenseStatCards(sheet: DcrSheet | undefined): LabeledStat[] {
  return [
    {
      key: 'expenseCount',
      label: 'Expenses',
      value: sheet?.expenses.length,
    },
    {
      key: 'expenseClaimed',
      label: 'Expense Claimed',
      value: sheet?.totals.expenseClaimed,
      unit: TAKA_SYMBOL,
    },
    {
      key: 'expenseApproved',
      label: 'Expense Approved',
      value: sheet?.totals.expenseApproved,
      unit: TAKA_SYMBOL,
    },
    getGrandTotalCard(sheet),
  ];
}

export function getInstituteVisitStatCards(
  visited: AssignedInstitute[] | undefined,
  missed: AssignedInstitute[] | undefined,
): LabeledStat[] {
  const assignedCount =
    visited === undefined || missed === undefined ? undefined : visited.length + missed.length;
  const visitDays = visited?.reduce((days, institute) => days + institute.visitDays, 0);

  return [
    {
      key: 'assigned',
      label: 'Assigned Institutes',
      value: assignedCount,
    },
    {
      key: 'visited',
      label: 'Visited',
      value: visited?.length,
    },
    {
      key: 'missed',
      label: 'Not Visited',
      value: missed?.length,
    },
    {
      key: 'visitDays',
      label: 'Visit Days',
      value: visitDays,
    },
  ];
}
